// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"f8c198f9","707":"7c912b78","949":"fc13f931"}[chunkId] + ".chunk.js";
};